/** "1265000.0000" → "1 265 000" */
export function fmtAmount(value: string | number | null | undefined): string {
  if (value == null || value === "") return "—";
  const n = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(n)) return String(value);
  return Math.round(n)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

/** "8433.333333" → "8 433,33" */
export function fmtPrice(value: string | number | null | undefined, decimals = 2): string {
  if (value == null || value === "") return "—";
  const n = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(n)) return String(value);
  const parts = n.toFixed(decimals).split(".");
  const int = parts[0] ?? "0";
  const frac = parts[1] ?? "";
  return `${int.replace(/\B(?=(\d{3})+(?!\d))/g, " ")},${frac}`;
}

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  return iso.length > 10 ? iso.slice(0, 10) : iso;
}

/** "184.5850" (already ×100) → "+184,59 %" */
export function fmtPct(value: string | number | null | undefined, decimals = 2): string {
  if (value == null || value === "") return "—";
  const n = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(n)) return String(value);
  const sign = n > 0 ? "+" : "";
  return `${sign}${n.toFixed(decimals).replace(".", ",")} %`;
}

/** Unsigned percentage, e.g. a target rate: "8,50 %". */
export function fmtRate(value: string | number | null | undefined, decimals = 2): string {
  if (value == null || value === "") return "—";
  const n = Number(value);
  return Number.isFinite(n) ? `${n.toFixed(decimals).replace(".", ",")} %` : String(value);
}
